import React from 'react';
import { Link } from 'react-router-dom';

const Home = () => {
  return (
    <div className="bg-gray-100">
      {/* Main Content */}
      <main className="flex-grow">
        <section className="bg-white py-16">
          <div className="max-w-3xl mx-auto text-center">
          <h1 className="text-4xl font-bold text-teal-900 mb-4">
            IBAN Analyzer API – Validate IBANs and Find Bank Information
          </h1>
            <p className="text-lg text-gray-700 mb-6">
              A powerful API for validating IBANs, retrieving detailed bank information, and analyzing account structures — built for developers and businesses.
            </p>

            <div className="space-y-4 mb-10">
              <Link
                to="/signup"
                className="block w-full max-w-xs mx-auto bg-teal-900 text-white py-2 px-4 rounded-lg hover:bg-teal-800 transition duration-200"
              >
                Get Started for Free
              </Link>
              <Link
                to="/login"
                className="block w-full max-w-xs mx-auto bg-gray-800 text-white py-2 px-4 rounded-lg hover:bg-gray-700 transition duration-200"
              >
                Login
              </Link>
            </div>

            <p className="text-gray-600 text-sm">
              Want to try it out without registering? Head over to our main site at{' '}
              <a
                href="https://www.iban-analyzer.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-teal-600 underline"
              >
                iban-analyzer.com
              </a>{' '}
              — it uses the exact same backend.
            </p>
          </div>
        </section>

        {/* Why Choose Us */}
        <section className="py-16 bg-gray-50">
          <div className="max-w-5xl mx-auto px-4">
            <h3 className="text-3xl font-bold text-center text-teal-800 mb-10">Why Choose IBAN Analyzer API?</h3>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8 text-gray-700">
              <div>
                <h4 className="font-semibold text-lg mb-2">✅ Accurate Validation</h4>
                <p>Country-specific IBAN validation checks using official rules.</p>
              </div>
              <div>
                <h4 className="font-semibold text-lg mb-2">🏦 Bank Info Lookup</h4>
                <p>Identify the bank, SWIFT/BIC, and other metadata directly from the IBAN.</p>
              </div>
              <div>
                <h4 className="font-semibold text-lg mb-2">🌍 90+ Countries</h4>
                <p>Extensive support for IBAN validation and bank info across Europe and beyond.</p>
              </div>
              <div>
                <h4 className="font-semibold text-lg mb-2">📊 Flexible Pricing</h4>
                <p>
                  Transparent and scalable plans. See our{' '}
                  <Link to="/pricing" className="text-teal-600 underline">
                    pricing page
                  </Link>{' '}
                  for details.
                </p>
              </div>
              <div>
                <h4 className="font-semibold text-lg mb-2">📦 Simple Integration</h4>
                <p>Clear documentation, examples, and instant access with your API key.</p>
              </div>
              <div>
                <h4 className="font-semibold text-lg mb-2">📞 Developer Support</h4>
                <p>
                  Questions? Contact us at{' '}
                  <a href="mailto:support@iban-analyzer.com" className="text-teal-600 underline">
                    support@iban-analyzer.com
                  </a>
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Explore More */}
        <section className="py-16 bg-white">
          <div className="max-w-4xl mx-auto text-center">
            <h3 className="text-2xl font-bold text-teal-800 mb-4">Explore the API</h3>
            <p className="text-gray-600 mb-6">
              View supported countries, check pricing, or read the full API documentation.
            </p>
            <div className="flex justify-center flex-wrap gap-4">
              <Link
                to="/docs"
                className="bg-teal-600 text-white px-6 py-2 rounded hover:bg-teal-700"
              >
                📘 API Documentation
              </Link>
              <Link
                to="/pricing"
                className="bg-gray-800 text-white px-6 py-2 rounded hover:bg-gray-700"
              >
                💰 View Pricing
              </Link>
              <Link
                to="/supported-countries"
                className="bg-gray-200 text-gray-800 px-6 py-2 rounded hover:bg-gray-300"
              >
                🌍 Supported Countries
              </Link>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Home;